
class FrontendLLMService {
  constructor() {

    // Übersetzung läuft serverseitig über das Backend (POST /translate).
    // Damit bleibt der LLM-Key serverseitig und der interne LiteLLM-Endpunkt
    // ist erreichbar (der Browser eines externen Nutzers erreicht ihn nicht).
    this.apiBaseURL = (process.env.VUE_APP_API_BASE_URL || 'https://api.ki.schuberth.com').replace(/\/+$/, '')
    this.timeout = parseInt(process.env.VUE_APP_LLM_TIMEOUT, 10) || 30000

    this.translationCache = new Map()
    this.cacheDuration = 24 * 60 * 60 * 1000 // 24 Stunden Cache
  }


  setConfig(config) {
    if (config.apiBaseURL) this.apiBaseURL = config.apiBaseURL.replace(/\/+$/, '')
    if (config.timeout) this.timeout = config.timeout
  }

  async translateText(text, targetLang, context = 'ui_text') {
    // Nichts zu übersetzen / Zielsprache ist Quellsprache
    if (!text || targetLang === 'de') {
      return text
    }

    // Cache-Key erstellen
    const cacheKey = `${targetLang}_${context}_${text}`

    // Cache prüfen
    const cached = this.translationCache.get(cacheKey)
    if (cached && Date.now() - cached.timestamp < this.cacheDuration) {
      //console.log(`📦 Verwende Cache für Übersetzung: ${text.substring(0, 50)}...`)
      return cached.translation
    }

    try {
      //console.log(`🌐 Übersetze Text (${targetLang}): ${text.substring(0, 50)}...`)

      const translation = await this.callBackend(text, targetLang)

      // In Cache speichern
      this.translationCache.set(cacheKey, {
        translation: translation.trim(),
        timestamp: Date.now()
      })

      //console.log(`✅ Übersetzt: "${text}" → "${translation}"`)
      return translation.trim()

    } catch (error) {
      console.error('❌ Übersetzungsfehler:', error)
      // Fallback: Originaltext zurückgeben
      return text
    }
  }

  async callBackend(text, targetLang, sourceLang = 'de') {
    try {
      const response = await fetch(`${this.apiBaseURL}/translate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          text,
          target_lang: targetLang,
          source_lang: sourceLang
        }),
        signal: AbortSignal.timeout(this.timeout)
      })

      if (!response.ok) {
        throw new Error(`Translate API Error: ${response.status} ${response.statusText}`)
      }

      const data = await response.json()

      if (!data || typeof data.translation !== 'string') {
        throw new Error('Ungültige Response vom Übersetzungs-Backend')
      }

      return data.translation

    } catch (error) {
      console.error('Übersetzungs-Aufruf fehlgeschlagen:', error)
      throw error
    }
  }

  // Batch-Übersetzung für mehrere Texte
  async translateMultiple(texts, targetLang, context = 'ui_text') {
    const translations = {}

    for (const [key, text] of Object.entries(texts)) {
      translations[key] = await this.translateText(text, targetLang, context)
    }

    return translations
  }

  // Cache löschen
  clearCache() {
    this.translationCache.clear()
  }

  // Health Check
  async healthCheck() {
    try {
      await this.translateText('Test', 'en', 'test')
      return { status: 'healthy' }
    } catch (error) {
      return { status: 'error', error: error.message }
    }
  }
}

export const frontendLLMService = new FrontendLLMService()
